import { z } from 'zod';

const baseLocalizedTextSchema = z.object({
  nl: z.string().optional(),
  fr: z.string().optional(),
  en: z.string().optional(),
});

export const localizedTextSchema = baseLocalizedTextSchema.refine(data => data.nl || data.fr || data.en, {
  message: 'Minstens één taal moet ingevuld zijn',
  path: [], // Show error on the field itself
});

export const optionalLocalizedTextSchema = baseLocalizedTextSchema.optional().transform(data => {
  // If all fields are empty strings, treat it as undefined
  if (data && !data.nl && !data.fr && !data.en) {
    return undefined;
  }
  return data;
});

export type LocalizedText = z.infer<typeof localizedTextSchema>;
